import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import SharedDataContext from "../../SharedDataContext";

export default function BillingTabs({ activeTab }) {
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const navigate = useNavigate();
  const tabs = [
    {
      name: "Usage",
      href: "/usage",
    },
    {
      name: "Plans",
      href: "/plans",
    },
    {
      name: "Billing",
      href: "/subscriptions",
    },
  ];

  return (
    <div className="border-b border-border mb-6 space-x-2 mt-6 mobile:space-x-0">
      {tabs &&
        tabs.length > 0 &&
        tabs.map((el) => (
          <Button
            className={`font-semibold mobile:w-6/12 mobile:ml-0 text-text-500 focus:bg-none px-5 rounded-none border-t-0 border-x-0 shadow-none ${
              el.name === activeTab
                ? "bg-transparent text-brand-700 pointer-events-none border-b-2 border-brand-600"
                : "border-b-2 border-transparent"
            }`}
            variant={el.name === activeTab ? "purple-outline" : "ghost"}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/${activeWorkspace?.slug}/settings/billing/${el.href}`);
            }}
          >
            {el.name}
          </Button>
        ))}
    </div>
  );
}
